<template>
    <div v-if="me" class="user-login-info" :class="{ 'user-login-info--holding': 0 < holdingCash }">
        <div class="user-login-info__wrap">
            <div class="user-login-info__left">
                <span class="font-size-16 font-size-md-18 font-size-lg-22"><b>{{ me.name }}</b>님<br class="d-lg-none"/> 반갑습니다.</span>
            </div>
            <div class="user-login-info__right font-size-14 font-size-md-18 text-right">
                <v-row no-gutters justify-md="end">
                    <v-col cols="12" md="auto">
                        <span>캐시잔액 : <b class="font-size-18 font-size-md-22 secondary--text">{{ me.cash.format() }}</b>원</span>
                        <!-- 홀딩(사용불가) 캐시는 잡혀있을 때만 노출한다 -->
                        <div v-if="0 < holdingCash" class="font-size-12 font-size-md-14 grey--text text--darken-1">사용불가 캐시 : <b>{{ holdingCash.format() }}</b>원</div>
                    </v-col>
                    <v-col cols="auto" class="d-none d-md-block">
                        <v-divider vertical class="mx-28px" style="max-height:14px; min-height:14px; border-color:#999;"/>
                    </v-col>
                    <v-col cols="12" md="auto">
                        <span>포인트 잔액 : <b class="font-size-18 font-size-md-22 secondary--text">{{ me.point.format() }}</b>원</span>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return { me: null }
    },
    mounted(){
        if(this.logon) this.search();
    },
    methods: {
        async search(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;
        }
    },
    computed: {
        logon(){ return !!this.$store.state.accessToken },

        // 관리자가 홀딩(지급정지)시켜 놓은 캐시 금액.
        // 전환/선물/교환 시 "잔액 - 사용금액 < 홀딩금액" 이면 차단되므로,
        // 회원 입장에서는 쓸 수 없는 캐시가 된다.
        // @see daehanbooks-backend routes/api/v1/gshop/orders/orders.controller.js
        // @see daehanbooks-backend routes/api/v1/me/gifts/gifts.controller.js
        holdingCash(){ return Number(this.me?.riskManagement?.cash?.limit) || 0 },
    },
    watch: {
        logon(){
            if(this.logon) this.search();
        }
    }

}
</script>

<style scoped>
.user-login-info{
    position: relative;
    z-index: 2;
    height: 80px;
}
.user-login-info__wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.user-login-info__left,
.user-login-info__right{
    padding: 14px;
}
.user-login-info__left{
    display: flex;
    align-items: center;
    width: 37.5%;
    /* height: 100%; */
    background: #cfcfd7;
}
.user-login-info__right{
    display: flex;
    align-items: center;
    width: calc(100% - 37.5%);
    /* height: 100%; */
}
/*
    사용불가 캐시 한 줄이 추가되면 고정높이(80px) + overflow:hidden 에 잘리므로,
    홀딩된 회원에게만 높이를 늘려준다. (홀딩이 없으면 기존 레이아웃 그대로)
*/
.user-login-info--holding,
.user-login-info--holding .user-login-info__wrap{
    height: auto;
    min-height: 80px;
}
.user-login-info--holding .user-login-info__left{
    align-self: stretch;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .user-login-info{
        border-radius: 24px 24px 0 0;
        background-color: rgba(255,255,255,.8);
        margin-top: -80px;
    }
    .user-login-info__left,
    .user-login-info__right{
        width:50%;
    }
    .user-login-info__left{
        background-color: transparent;
        padding-left:40px;
    }
    .user-login-info__right{
        padding-right:40px;
    }
}
@media (min-width:1200px){
}
</style>